import React from 'react';
import { motion } from 'framer-motion';
export interface Option {
  id: string;
  emoji: string;
  text: string;
}
interface QuestionScreenProps {
  question: string;
  options: Option[];
  selectedOptionId?: string;
  onSelect: (id: string) => void;
  onNext: () => void;
}
export function QuestionScreen({
  question,
  options,
  selectedOptionId,
  onSelect,
  onNext
}: QuestionScreenProps) {
  return <div className="flex flex-col min-h-[calc(100vh-100px)] bg-[#f4ebd0] px-5 py-8 max-w-md mx-auto w-full relative pt-[20px] pb-[20px]" data-id="element-40">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'url("https://www.transparenttextures.com/patterns/wood-pattern.png")'
    }} data-id="element-41"></div>

      <div className="relative z-10 flex-grow flex flex-col" data-id="element-42">
        <motion.h2 initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.35,
        delay: 0.05
      }} className="font-bold text-amber-950 mb-8 text-center text-[23px]" data-id="element-43">
          {question}
        </motion.h2>

        <div className="flex flex-col gap-4 flex-grow" data-id="element-44">
          {options.map((option, index) => {
          const isSelected = selectedOptionId === option.id;
          return <motion.button key={option.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.35,
            delay: 0.1 + index * 0.07,
            ease: [0.22, 1, 0.36, 1]
          }} whileTap={{
            scale: 0.97
          }} onClick={() => onSelect(option.id)} className={`${`
                  flex items-center p-5 rounded-2xl text-left transition-all duration-200 border-2
                  ${isSelected ? 'bg-amber-50 border-amber-600 shadow-[0_4px_20px_rgba(217,119,6,0.15)] transform scale-[1.01]' : 'bg-white border-transparent shadow-sm hover:shadow-md hover:border-amber-200'}
                `} pt-[16px] pb-[16px] pl-[11px] pr-[11px]`} data-id="element-45">
                <span className="text-3xl mr-4 flex-shrink-0" data-id="element-46">
                  {option.emoji}
                </span>
                <span className={`text-base font-semibold ${isSelected ? 'text-amber-900' : 'text-stone-700'}`} data-id="element-47">
                  {option.text}
                </span>

                <div className={`ml-auto flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors
                  ${isSelected ? 'border-amber-600 bg-amber-600' : 'border-stone-300'}
                `} data-id="element-48">
                  {isSelected && <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-49">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-50" />
                    </svg>}
                </div>
              </motion.button>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.35,
        delay: 0.1 + options.length * 0.07
      }} className="mt-8 pt-4 pb-6 sticky bottom-0 bg-gradient-to-t from-[#f4ebd0] via-[#f4ebd0] to-transparent" data-id="element-51">
          <button onClick={onNext} disabled={!selectedOptionId} className={`
              w-full py-4 px-6 rounded-xl font-bold text-lg flex items-center justify-center gap-2 transition-all
              ${selectedOptionId ? 'bg-amber-800 hover:bg-amber-900 text-white shadow-lg transform hover:-translate-y-1' : 'bg-stone-300 text-stone-500 cursor-not-allowed'}
            `} data-id="element-52">
            Siguiente
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-53">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-54" />
            </svg>
          </button>
        </motion.div>
      </div>
    </div>;
}